var map = {
  "./en.json": [
    "74305",
    "8401"
  ],
  "./da.json": [
    "729",
    "8861"
  ],
  "./pl.json": [
    "48950",
    "8756"
  ],
  "./sv.json": [
    "13651",
    "1927"
  ],
  "./nl.json": [
    "2420",
    "9294"
  ],
  "./lt.json": [
    "26906",
    "7208"
  ],
  "./lv.json": [
    "77672",
    "3074"
  ],
  "./nl_BE.json": [
    "6812",
    "402"
  ],
  "./de.json": [
    "36333",
    "4441"
  ],
  "./es.json": [
    "88962",
    "7732"
  ],
  "./fr.json": [
    "59962",
    "1168"
  ],
  "./it.json": [
    "40035",
    "7463"
  ],
  "./no.json": [
    "34849",
    "7293"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 78367;
module.exports = __rspack_async_context;
